module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"more »":"подробнее »","Optimal balance in Reserves":"В резервах оптимальная сумма"}}')
  delete Component.options._Ctor
}
